import React from 'react';

import { Box, Chip, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { IDraft } from '../../interfaces/IDraft';
import { IOptions } from '../../interfaces/IOptions';
import { RootState, useTypedSelector } from '../../redux/store';

const ConnectedDraft = () => {
  const navigate = useNavigate();
  const { connectedDrafts } = useTypedSelector(
    (state: RootState) => state.draft
  );

  return (
    <Stack gap={2} p={2}>
      {connectedDrafts?.map((data: IDraft, index: number) => (
        <Box
          key={index}
          sx={{
            background: 'white',
            borderRadius: '8px',
            padding: '8px 16px',
            cursor: 'pointer',
          }}
          onClick={() => navigate(`/drafts/view-draft/${data.id}`)}
        >
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {data.name}
              <br />
              <Typography variant="caption">
                {data?.contract_type?.contract_type}
              </Typography>
            </Typography>
            <Stack gap={2}>
              {data.groups.map((element, index: number) => (
                <Chip
                  color="success"
                  key={index}
                  label={(element as IOptions).name?.replace('/', '')}
                />
              ))}
            </Stack>
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};

export default ConnectedDraft;
